export default "__VITE_ASSET__DtlDtzGb__"